var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: {
      title: "图片列表-1",
      component_name: "4-1-img-list-1",
      initConfigNum: 2,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }